import React, { useState } from "react";
import { useEffect } from "react"

import "./teamStatsAnalytics.scss";
import StackBarChart from "../StackBarChart";
import useStatsStore from "../../store/stats.store";  
import useMembersStore from "../../store/members.store";
import Filter from "../filter";
import FilterSourcing from "../filterSourcing";

export default function TeamStatsAnalytics({ inputData, buttonName, title }) {

  const { graphsGroupUserStats,graphsGroupAllStats} = useStatsStore();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const { currSubscription } = useMembersStore();
  const { getGraphsGroupUserStats,getGraphsAllStats} = useStatsStore();

  const [stackBarChartAll, setStackBarChartAll] = useState(null);
  const [resumeQualityBarChartAll, setResumeQualityBarChartAll] = useState(null);
  const [candidateStatusBarChartAll, setCandidateStatusBarChartAll] = useState(null);
  const [resumeStatusBarChartAll, setResumeStatusBarChartAll] = useState(null);
  const [interviewTypeBarChartAll, setInterviewTypeBarChartAll] = useState(null);
  const [interviewStatusBarChartAll, setInterviewStatusBarChartAll] = useState(null);
  const [selectionStatusBarChartAll, setSelectionStatusBarChartAll] = useState(null);
  const [onboardingBarChartAll, setOnboardingBarChartAll] = useState(null);
  const [rdbMediumBarChartAll, setRDBMediumBarChartAll] = useState(null);
  const [sourcingMediumBarChartAll, setSourcingMediumBarChartAll] = useState(null);
  const [extraAnalysisBarChartAll, setExtraAnalysisBarChartAll] = useState(null);
 
  const candidateStatusConfigs = [
    { key: "NoOfResumesToBeCalled", label: "To Be Called" },
    { key: "NoOfResumesNotPicking", label: "Not Picking" },
    { key: "NoOfResumesDisconnected", label: "Disconnected" },
    { key: "NoOfResumesBusy", label: "Busy" },
    { key: "NoOfResumesOOS", label: "OOS" },
    { key: "NoOfResumesSwitchOFF", label: "Switch OFF" },
    { key: "NoOfResumesCallLater", label: "Call Later" },
    { key: "NoOfResumesJDNeeded", label: "JD Needed" },
    { key: "NoOfResumesAvailable", label: "Available" },
    { key: "NoOfResumesAvailableHCTC", label: "Available HCTC" },
    { key: "NoOfResumesAvailableHNP", label: "Available HNP" },
    { key: "NoOfResumesNotInterested", label: "Not Interested" },
    { key: "NoOfResumesClientDirectPayroll", label: "Client Direct Payroll" },
    { key: "NoOfResumesAlreadyApplied", label: "Already Applied" },
    { key: "NoOfResumesAlreadyGotCall", label: "Already Got Call" },
    { key: "NoOfResumesInterviewdIn6Months", label: "Interviewed In 6 Months" },
    { key: "NoOfResumesInterviewdBefore6Months", label: "Interviewed Before 6 Months" },
    { key: "NoOfResumesLocationIssue", label: "Location Issue" },
    { key: "NoOfResumesNotLooking", label: "Not Looking" },
    { key: "NoOfResumesNotSuitable", label: "Not Suitable" },
    { key: "NoOfResumesPending", label: "Pending" },
  ].map((item, index, arr) => ({
    ...item,
    color: `hsl(${Math.round((index * 360) / arr.length)}, 50%, 55%)`,
  }));

  const initCandidateStatusCharts = () =>{
      var candidateStatusBarChartAllTmp = {
        labels: [''],
        datasets: candidateStatusConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.candidatestatus?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setCandidateStatusBarChartAll(candidateStatusBarChartAllTmp)           
  }

  const resumeStatusConfigs = [
    { key: "NoOfScreenRejected", label: "Screen Rejected" },
    { key: "NoOfScreenRejectedHCTC", label: "Screen Rejected HCTC" },
    { key: "NoOfScreenRejectedHNP", label: "Screen Rejected HNP" },
    { key: "NoOfShared", label: "Shared" },
    { key: "NoOfReviewPending", label: "Review Pending" },
    { key: "NoOfFBPending", label: "Feedback Pending" },
    { key: "NoOfClientFBPending", label: "Client Feedback Pending" },    
    { key: "NoOfScreenSelected", label: "Screen Selected" },
    { key: "NoOfScreenPartialSuitable", label: "Screen Partial Suitable" },
    { key: "NoOfDuplicate", label: "Duplicate" },  
    { key: "NoOfInterviewRejected", label: "Interview Rejected" },      
  ].map((item, index, arr) => ({
    ...item,
    color: `hsl(${Math.round((index * 360) / arr.length)}, 50%, 55%)`,
  }));
  
  const initResumeStatusCharts = () =>{
      var resumeStatusBarChartAllTmp = {
        labels: [''],
        datasets: resumeStatusConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.resumestatus?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setResumeStatusBarChartAll(resumeStatusBarChartAllTmp)           
  }  

  const interviewStatusConfigs = [
  { key: "NoOfInterviewStatusRejected", label: "Rejected" },
  { key: "NoOfInterviewStatusNoShow", label: "No Show" },
  { key: "NoOfInterviewStatusCandidateDrop", label: "Candidate Drop" },
  { key: "NoOfInterviewStatusCandidateNP", label: "Candidate Not Picked" },
  { key: "NoOfInterviewStatusSelected", label: "Selected" },
  { key: "NoOfInterviewStatusFinalSelect", label: "Final Select" }, 
  { key: "NoOfInterviewStatusDone", label: "Done" },  
  { key: "NoOfInterviewStatusPanelNotJoined", label: "Panel Not Joined" },
  { key: "NoOfInterviewStatusNoPanel", label: "No Panel" },
  { key: "NoOfInterviewStatusCancelled", label: "Cancelled" },
  { key: "NoOfInterviewStatusHold", label: "Hold" },
  { key: "NoOfInterviewStatusYTBS", label: "Yet To Be Scheduled" },
  { key: "NoOfInterviewStatusYTBRS", label: "Yet To Be Re-Scheduled" },
  { key: "NoOfInterviewStatusScheduled", label: "Scheduled" },
  { key: "NoOfInterviewStatusReScheduled", label: "Re-Scheduled" },
   
  ].map((item, index, arr) => ({
    ...item,
    color: `hsl(${Math.round((index * 360) / arr.length)}, 50%, 55%)`,
  }));
  
  const initInterviewStatusCharts = () =>{
      var interviewStatusBarChartAllTmp = {
        labels: [''],
        datasets: interviewStatusConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.interviewstatus?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setInterviewStatusBarChartAll(interviewStatusBarChartAllTmp)           
  }  
  const interviewTypeConfigs = [
  { key: "NoOfInterviewTypePreScreening", label: "Pre Screening" },
  { key: "NoOfInterviewTypeL0", label: "L0" },
  { key: "NoOfInterviewTypeL1", label: "L1" },
  { key: "NoOfInterviewTypeL2", label: "L2" },
  { key: "NoOfInterviewTypeCustomer", label: "Customer" },
  { key: "NoOfInterviewTypeHR", label: "HR" },
  { key: "NoOfInterviewTypeMGMT", label: "Management" },
  
  ].map((item, index, arr) => ({
    ...item,
    color: `hsl(${Math.round((index * 360) / arr.length)}, 50%, 45%)`,
  }));
  
  const initInterviewTypeCharts = () =>{
      var interviewTypeBarChartAllTmp = {
        labels: [''],
        datasets: interviewTypeConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.interviewtype?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setInterviewTypeBarChartAll(interviewTypeBarChartAllTmp)           
  }  

  const selectionStatusConfigs = [
  { key: "numfinalselected", label: "Final Selected" },
  { key: "numoffered", label: "Offered" },
  { key: "numofferpending", label: "Offer Pending" },
  { key: "numofferaccepted", label: "Offer Accepted" },
  { key: "numofferonhold", label: "Offer On Hold" },
  { key: "numdeclined", label: "Declined" },
  { key: "numjoined", label: "Joined" },

  ].map((item, index, arr) => ({
    ...item,
    color: `hsl(${Math.round((index * 360) / arr.length)}, 50%, 55%)`,
  }));
  
  const initSelectionStatusCharts = () =>{
      var selectionStatusBarChartAllTmp = {
        labels: [''],
        datasets: selectionStatusConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.offers?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setSelectionStatusBarChartAll(selectionStatusBarChartAllTmp)           
  }  
  const resumeQualityConfigs = [
    { key: "numaboveaverage", label: "Above Average", color: "rgba(227, 186, 125, 0.7)" },
    { key: "numaverage", label: "Average", color: "rgba(225, 100, 167, 0.7)" },
    { key: "numbelowsverage", label: "Below Average", color: "rgba(130, 224, 210, 0.7)" },
    { key: "numnotsuitable", label: "Not Suitable", color: "rgba(165, 171, 0, 0.7)" },
    { key: "numsuitable", label: "Suitable", color: "rgba(34, 153, 84, 0.7)" },
  ];
  const initResumeQualityCharts = () =>{
      const totalResumes = resumeQualityConfigs.reduce(
        (sum, item) => sum + (graphsGroupAllStats?.allresumequality?.[item.key] ?? 0),
        0
      );

      var resumeQualityBarChartAllTmp = {
        labels: [`Total Applications: ${totalResumes}`],
        datasets: resumeQualityConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.allresumequality?.[item.key] ?? 0],
          backgroundColor: item.color,
        })),
      };
      setResumeQualityBarChartAll(resumeQualityBarChartAllTmp)           
  }

  const statConfigs = [
    { key: "numjds", label: "JDs", color: "rgba(227, 186, 125, 0.7)" },
    { key: "numvendors", label: "Vendors", color: "rgba(130, 224, 210, 0.7)" },
    { key: "numusers", label: "Users", color: "rgba(165, 171, 0, 0.7)" },
    { key: "numinterviews", label: "Interviews", color: "rgba(34, 153, 84, 0.7)" },
    { key: "numoffered", label: "Offers", color: "rgba(34, 153, 84, 0.7)" },
    { key: "numjoined", label: "Joined", color: "rgba(34, 153, 84, 0.7)" },
  ];

  const initNumCharts = () =>{
      var stackBarChartAllTmp = {
        labels: [`Total Resumes in DB: ${graphsGroupAllStats?.numresumes??0}`],
        datasets: statConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setStackBarChartAll(stackBarChartAllTmp)           
  }

  const sourcingMediumConfigs = [
    { key: "NoOfResumesNuJobs", label: "By NuJobs", color: "rgba(227, 125, 201, 0.7)" },
    { key: "NoOfResumesSourced", label: "By Team", color: "rgba(130, 224, 210, 0.7)" },
    { key: "NoOfResumesAutomation", label: "By Automation", color: "rgba(165, 171, 0, 0.7)" },
    { key: "NoOfResumesVendors", label: "By Vendor", color: "rgba(34, 153, 84, 0.7)" },
  ];

  const initSourcingMediumCharts = () =>{
      var sourcingMediumBarChartAllTmp = {
        labels: [''],
        datasets: sourcingMediumConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.candidatestatus?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setSourcingMediumBarChartAll(sourcingMediumBarChartAllTmp)           
  }

  const rdbMediumConfigs = [
    { key: "NoOfResumesNuJobs", label: "By NuJobs", color: "rgba(227, 125, 201, 0.7)" },
    { key: "NoOfResumesSourced", label: "By Team", color: "rgba(130, 224, 210, 0.7)" },
    { key: "NoOfResumesVendors", label: "By Vendor", color: "rgba(34, 153, 84, 0.7)" },
  ];

  const initRDBMediumCharts = () =>{
      const totalResumes = rdbMediumConfigs.reduce(
        (sum, item) => sum + (graphsGroupAllStats?.rdbstatus?.[item.key] ?? 0),
        0
      );    
      var rdbMediumBarChartAllTmp = {
        labels: [`Total Resumes in DB: ${totalResumes}`],
        datasets: rdbMediumConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.rdbstatus?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setRDBMediumBarChartAll(rdbMediumBarChartAllTmp)           
  }
    const onboardingConfigs = [
    { key: "numbgvongoing", label: "BGV Ongoing", color: "rgba(227, 125, 201, 0.7)" },
    { key: "numbgvok", label: "BGV OK", color: "rgba(130, 224, 210, 0.7)" },
    { key: "numbgvfail", label: "BGV Fail", color: "rgba(165, 171, 0, 0.7)" },
    { key: "numdocsongoing", label: "Docs Ongoing", color: "rgba(34, 153, 84, 0.7)" },
    { key: "numdoc sok", label: "Docs OK", color: "rgba(34, 153, 84, 0.7)" },
    { key: "numdocsfail", label: "Docs Fail", color: "rgba(34, 153, 84, 0.7)" },
  ];

  const initOnboardingCharts = () =>{
      var onboardingBarChartAllTmp = {
        labels: [''],
        datasets: onboardingConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.offers?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setOnboardingBarChartAll(onboardingBarChartAllTmp)           
  }
  
  const extraAnalysisConfigs = [
    { key: "NoOfResumesAvailableHCTC", label: "HCTC", color: "rgba(227, 125, 201, 0.7)" },
    { key: "NoOfResumesAvailableHNP", label: "HNP", color: "rgba(130, 224, 210, 0.7)" },
    { key: "NoOfResumesAvailableImmediateJoiners", label: "Immediate Joiners", color: "rgba(34, 153, 84, 0.7)" },
  ];

  const initExtraAnalysisCharts = () =>{
      var extraAnalysisBarChartAllTmp = {
        labels: [``],
        datasets: extraAnalysisConfigs.map((item) => ({
          label: item.label,
          data: [graphsGroupAllStats?.candidatestatus?.[item.key]??0],
          backgroundColor: item.color,
        })),
      };
      setExtraAnalysisBarChartAll(extraAnalysisBarChartAllTmp)           
  }  

  useEffect(() => {    
    if (currSubscription == null) return;  // skip if null
  
    if((currSubscription == "trial_active")||(  currSubscription == "subscription_active")){
          //disable the model
          //let encodedJsonValues1 ={};
          //encodedJsonValues1.group = "All";
         // getGraphsAllStats("All",{...encodedJsonValues1});
    }
  }, [currSubscription]);
  
  useEffect(() => {    
    initNumCharts();
    initResumeQualityCharts();
    initCandidateStatusCharts();
    initResumeStatusCharts();
    initInterviewTypeCharts();
    initInterviewStatusCharts();
    initSelectionStatusCharts();
    initSourcingMediumCharts();
    initOnboardingCharts();
    initRDBMediumCharts();
    initExtraAnalysisCharts();
  }, [graphsGroupAllStats]);


  // if stackBarChartAll is null, we can return a loading state or null
  if (!stackBarChartAll) {
    return <div>Loading...</div>;
  }

  return (
        <div className="teamstatsanalytics-summary-wrapper">
          <FilterSourcing
            filtername = {"getGraphsAllStats"}
            initDuration={"24"}
            enableTeamMember  
            enableTAs 
            enableCustomers
            enableDuration
            handleFilter={getGraphsAllStats}
          />            
          <div></div>
        
          <div className="activity-summary-main-wrapper">
                <div className="activity-wrapper">
                      <div className = "activity-bar-stackChart-wrapper">
                          <StackBarChart stackBarData={stackBarChartAll} stack = {false} showTitle={"General Stats - All" } MAX = {50}/>
                          <StackBarChart stackBarData={resumeQualityBarChartAll} stack = {false} showTitle={"All Resume Quality"} MAX = {50}/>
                          <StackBarChart stackBarData={selectionStatusBarChartAll} stack = {false} showTitle={"Selection And Offer Status"} MAX = {50}/> 
                          <StackBarChart stackBarData={onboardingBarChartAll} stack = {false} showTitle={"Onboarding Status"} MAX = {50}/>                                                                       
                          <StackBarChart stackBarData={rdbMediumBarChartAll} stack = {false} showTitle={"RDB Source"} MAX = {50}/>                                                 
                          <StackBarChart stackBarData={candidateStatusBarChartAll} stack = {false} showTitle={"Candidate Status"} MAX = {50}/>
                          <StackBarChart stackBarData={extraAnalysisBarChartAll} stack = {false} showTitle={"Extra Analysis"} MAX = {50}/>                          
                          <StackBarChart stackBarData={resumeStatusBarChartAll} stack = {false} showTitle={"Resume Status"} MAX = {50}/>
                          <StackBarChart stackBarData={interviewTypeBarChartAll} stack = {false} showTitle={"Interview Type"} MAX = {50}/>
                          <StackBarChart stackBarData={interviewStatusBarChartAll} stack = {false} showTitle={"Interview Status"} MAX = {50}/>
                      </div>
         
                </div>
          </div>
        </div>
    );
}
